import React, { useEffect, useMemo, useState } from "react";
import {
  BrowserRouter,
  HashRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import "../src/styles/App.css";
import "./i18n/i18n";

import ProgressBlock from "./components/ProgressBlock/ProgressBlock";
import { common_route, routes } from "./utils/routes";
import OverflowHidden from "./utils/OverflowHidden";
import ShouldHideMenu from "./utils/hideMenu";
import useDeviceType from "./hook/useDeviceType";
import { API_RELOAD, BACK_DASHBOARD, BALANCE_RELOAD } from "./constant";
import { BasicApi } from "./api/basicApi";
import { allGameList, allGamePlatform, allGameType } from "./api/fakeGame";
import LanguagePage from "./pages/Settings/components/LanguagePage";
import { CheckGoogleLogin } from "./hook/useGoogleLogin";
import NotFoundPage from "./components/ProgressBlock/NotFoundPage";
import Wrapper from "./components/Wrapper";
import CommonHelmet from "./components/Seo/commonHelmet";
import "../src/styles/splide.css";
import DescriptionDashboard from "./pages/Game/gameDescription/descriptionDashboard";
import ServicePing from "./pages/Service/ServicePing";
import TagManager from "react-gtm-module";
import { ErrorBoundary } from "react-error-boundary";
import Echo from "laravel-echo";
import Cookies from "js-cookie";
import { useChannelListener } from "./hook/useChannelListener";
import { notice } from "./redux/action/action";
import { cleanMemberInfo } from "./redux/action/member/memberAction";
import Home from "./pages/Home/Home";
import WalletSetting from "./components/SignInUp/components/WalletSetting";
import { getEventList } from "./api/getApi";
import ColorModePage from "./pages/Settings/components/colorModePage";
import PageProgress from "./components/ProgressBlock/PageProgress";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import LiveChat from "./components/LiveChat/LiveChat";
import GoogleNotification from "./pages/Singin/components/GoogleNotification";
import axios from "axios";
import ReactGA from "react-ga4";
import StatusModal from "./pages/StatusModal/StatusModal";
import LoadingPage from "./components/Loading/LoadingPage";

const tagManagerArgs = {
  gtmId: "GTM-WG37W8RW",
};

// TagManager.initialize(tagManagerArgs);
ReactGA.initialize("G-Z5K41K29MR");

function App() {
  const { i18n } = useTranslation();

  const dispatch = useDispatch();
  const isDarkMode = useSelector((state) => state.isTheme === "dark");

  const navigate = useNavigate();
  const location = useLocation();

  // useEffect(() => {
  //   if (location.pathname?.includes("nAdmin3")) {
  //     window.location.href = BACK_DASHBOARD;
  //   }
  //   if (
  //     location.pathname?.includes("settings.php") ||
  //     location.pathname?.includes("signup.php")
  //   ) {
  //     navigate("/casino/signup" + location.search);
  //   }
  //   caches.keys().then((keyList) => {
  //     return Promise.all(
  //       keyList.map((key) => {
  //         return caches.delete(key);
  //       })
  //     );
  //   });
  // }, []);

  // useChannelListener("userBalance", "BalanceUpdated", (e) => {
  //   if (e?.message === "reload") {
  //     dispatch({ type: "GET_BALANCE", navigate: navigate });
  //   }
  //   console.log(e);
  // });

  // useChannelListener("listenTokenChanger", "ListenTokenChanger", (e) => {
  //   if (e?.tmpToken !== Cookies.get("tmpToken")) {
  //     dispatch({ type: "USER_LOGOUT", navigate: navigate });
  //   }
  //   console.log(e);
  // });

  const deviceType = useDeviceType();
  const hideMenu = ShouldHideMenu();

  const { lang } = useParams();

  const locationChanger = useMemo(() => {
    if (location.pathname?.includes("profile")) {
      return false;
    } else {
      return location.key;
    }
  }, [location]);

  useEffect(() => {
    const className = "dark";
    const bodyClasses = document.body.classList;

    isDarkMode ? bodyClasses.add(className) : bodyClasses.remove(className);
  }, [isDarkMode]);

  useEffect(() => {
    BasicApi(dispatch)();
    dispatch({ type: "INITIALIZE_API", navigate: navigate });
  }, []);

  const languagePop = useSelector((state) => state.isLanguagePop);
  const walletSettingPop = useSelector((state) => state.isWalletSettingPop);
  const comissionListPop = useSelector((state) => state.isComissionListPop);
  const colorTab = useSelector((state) => state.isColorMode);
  const isGameDescriptionConfig = useSelector(
    (state) => state.isGameDescriptionPop
  );

  // useEffect(() => {
  //   if (i18n.resolvedLanguage !== lang) {
  //     if (i18n.options.fallbackLng.includes(lang)) {
  //       i18n.changeLanguage(lang);
  //     } else {
  //       navigate("/" + i18n.resolvedLanguage + location.pathname, {
  //         replace: true,
  //       });
  //     }
  //   }
  // }, [lang]);

  useEffect(() => {
    const fetchDataPeriodically = () => {
      dispatch({ type: "UPDATE_DATA_PERIODICALLY", navigate: navigate });
      // dispatch({ type: "CURRENCY_EXCHANGER" });
    };

    const apiIterval = setInterval(() => {
      fetchDataPeriodically();
    }, API_RELOAD);

    return () => clearInterval(apiIterval);
  }, []);

  return (
    <ErrorBoundary fallback={<div>&nbsp;</div>}>
      <GoogleNotification />
      <CommonHelmet />
      <section
        className={`${
          deviceType === "PC"
            ? hideMenu
              ? " w-full"
              : "pl-[320px] w-full"
            : ""
        }`}
      >
        <PageProgress key={locationChanger} />

        <Routes location={location}>
          {routes
            ?.filter((route) => !route.hidden)
            ?.map((route, index) => {
              return (
                <Route
                  key={route.path}
                  path={`${route.path}`}
                  element={route.element}
                >
                  {common_route?.map((child, index) => {
                    return (
                      <Route
                        key={child.path}
                        exact={child.exact}
                        path={`${child.path}`}
                        element={
                          <OverflowHidden>
                            {child.element}
                            <Outlet key={child.path} />
                          </OverflowHidden>
                        }
                      >
                        {child.children?.map((item) => {
                          return (
                            <Route
                              exact={item.exact}
                              key={item.path}
                              path={`${item.path}`}
                              element={
                                <>
                                  {item.element}
                                  <Outlet />
                                </>
                              }
                            />
                          );
                        })}
                      </Route>
                    );
                  })}
                </Route>
              );
            })}
          <Route path="*" element={<Navigate to={`/${i18next.language}`} />} />
        </Routes>
      </section>
      <ProgressBlock />
      {colorTab && <ColorModePage />}
      {languagePop && <LanguagePage />}
      {walletSettingPop && <WalletSetting />}
      {isGameDescriptionConfig?.state === true && <DescriptionDashboard />}
      <LoadingPage />
      <LiveChat />
      <StatusModal />
    </ErrorBoundary>
  );
}

export default React.memo(App);
